import { world } from '../../languages';
import getDisposableToken from '../authorization/get-disposable-token';

type Props = {
    id: string | number;
    isDirectLink?: boolean;
    isFree?: boolean;
    orderToken?: string | string[] | null;
};

export const getDownloadHref: (p: Props) => Promise<void> = async ({ id, isFree, isDirectLink, orderToken }) => {
    const { access_token } = await getDisposableToken('download');
    const url = (process.env.REACT_APP_API_URL || '')?.replace('api/', '');
    const download = isFree ? 'download-free' : 'download';
    const directLink = isDirectLink ? '&directLink=true' : '';
    const order_token = orderToken ? `&order_token=${orderToken}` : '';

    window.location.href = `${url}acl/${download}?id=${id}&world=${world}&access_token=${access_token}${order_token}${directLink}`;
};
